var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-grow flex justify-between h-full bg-white"},[_c('window-search',{attrs:{"fetch-data":_vm.fetchData,"columns":_vm.columns},on:{"selected":_vm.selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }